import React from "react";
import '../css/policies.css'

const TermsAndCond = () => {
  return (
    
    <div className="policy-p">
      <h1 style={{ textAlign: "center" }}>Terms & Conditions</h1><br />
      <p>
         1.This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
               </p>
      <p>
        2.This document is published in accordance with the provisions of Rule 3 (1) of the Information
        Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and
        regulations, privacy policy, and Terms of Use for access or usage of domain name <b>
        www.shrisadgurudajimaharaj.org ("Website"),</b> including the related mobile site and mobile
        application (hereinafter referred to as "Platform").
      </p>
      <p>
        3.The Platform is owned by <b>Sacchidanand Ved Swadhyay Pratishthan,</b> a company incorporated under
        the Companies Act,<b> 1956 with its registered office at At post Dhangar Takali, Tq Purna, Dist
        Parbhani, India 431511 </b>(hereinafter referred to as "Platform Owner," "we," "us," "our").
      </p>
      <p>
        4.Your use of the Platform and services and tools are governed by the following terms and
        conditions <b> ("Terms of Use") </b>as applicable to the Platform, including the applicable policies
        which are incorporated herein by way of reference. By mere use of the Platform, you shall be
        contracting with the Platform Owner and these terms and conditions, including the policies,
        constitute your binding obligations with the Platform Owner.
      </p>
      <p>
      5.These Terms of Use relate to your use of our website, <b>goods (as applicable) or services (as applicable) (collectively, 'Services').</b> 
      Any terms and conditions proposed by 
      You which are in addition to or which conflict with these Terms of Use are expressly rejected by the Platform 
      Owner and shall be of no force or effect. 
      These Terms of Use can be modified at any time without assigning any reason. It is your responsibility to 
      periodically review these Terms of Use to stay informed of updates..
      </p>
      <p>
     6.For the purpose of these Terms of Use, wherever the context so requires ?you?, 'your' or ?user? shall mean any natural or legal person who has agreed to become a user/buyer on the Platform..
      </p>
      <p>
        <b>
        7. ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING
        </b>
      </p>
      <ul>
        <li>You agree to provide true, accurate, and complete information during registration.</li>
        <li>
          Neither we nor any third parties provide any <b>warranty or guarantee</b> regarding the
          completeness or accuracy of the information on this platform.
        </li>
        <li>
          Your use of our Services and the Platform is solely and entirely at your own risk.
        </li>
        <li>
          Unauthorized use of the Platform and/or the Services may lead to <b>legal action</b>.
        </li>
        <li>You agree to pay any applicable charges associated with the Services.</li>
        <li>
          You agree not to use the Platform for any <b>unlawful or illegal</b> purposes.
        </li>
        <li>
          You understand that initiating a transaction for the Services constitutes a legally binding
          agreement.
        </li>
        <li>
          You shall indemnify and hold harmless the Platform Owner against any claims arising from
          your breach of these terms.
        </li>
        <li>
          These Terms are <b>governed by the laws of India</b> and disputes are subject to the courts in
          Maharashtra.
        </li>
      </ul>
      <p>
        For detailed terms, conditions, and privacy policies, please contact us using the information
        provided on this website.
      </p>
    </div>
  );
};

export default TermsAndCond;
